import React, { useEffect, useState } from "react";
import styles from "./PDOModel.module.css";
import CancerName from "./CancerName";
import downTriangleIcon from "../../img/icon/DownTriangleIcon.png";
import sideTriangleIcon from "../../img/icon/SideTriangleIcon.png";

// props 대신 { name, search, returnFalse } 구조 분해 할당
function PDOModel({ name, search, returnFalse }) {
    const [visibleFirst, setVisibleFirst] = useState(false);
    const [cancerDatas, setData] = useState([]);
    
    // 페이지네이션 상태
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; 

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = cancerDatas.slice(indexOfFirstItem, indexOfLastItem);

    const handlePageClick = (pageNumber) => setCurrentPage(pageNumber);

    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(cancerDatas.length / itemsPerPage); i++) {
        pageNumbers.push(i);
    }

    // 삼항 연산자로 간소화
    const checkZero = (num) => (num === 0 || !num ? '' : `(${num})`);

    useEffect(() => {
        // 🚨 프론트엔드에서 SQL 쿼리(str) 조립하던 위험한 로직 완전 삭제!
        // 이제 백엔드에 순수하게 검색어(search)와 카테고리 이름(name)만 보냅니다.
        const reqOption = {
            method: "POST", // 소문자 post 보다는 대문자 POST가 표준입니다.
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify({
                name: name,     // 카테고리 이름
                search: search  // 검색어 (없으면 빈 문자열)
            })
        };

        fetch('/api/getCancerData', reqOption)
            .then((response) => response.json())
            .then(data => {
                setData(data);
                setCurrentPage(1); // ★ 검색어나 카테고리가 바뀌면 페이지를 1페이지로 초기화해주는 것이 UX에 좋습니다.
            })
            .catch(err => console.error("Data fetch error:", err));
    }, [search, name]);

    return (
        <div className={styles.pdoObject}>
            {/* 개별 span 대신 전체를 감싸는 div에 onClick을 걸어 코드를 줄입니다. */}
            <div onClick={() => setVisibleFirst(!visibleFirst)} style={{ cursor: 'pointer' }}>
                <span className={styles.outlinePdo}>
                    <img 
                        className={visibleFirst ? styles.minusImg_low : styles.plusImg_low} 
                        src={visibleFirst ? downTriangleIcon : sideTriangleIcon} 
                        alt={visibleFirst ? "Collapse" : "Expand"} 
                    />
                </span>
                <span className={styles.pdoName}>
                    {name}
                    <span className={styles.cancerDataNum}>
                        {checkZero(cancerDatas.length)}
                    </span>
                </span>
            </div>
            
            {visibleFirst && (
                <div className={styles.contentContainer}>
                    <div className={styles.cancerNamesContainer}>
                        {currentItems.map((data, index) => (
                            // 래퍼 함수 제거하고 다이렉트로 returnFalse 전달
                            <CancerName 
                                data={data} 
                                returnFalse={returnFalse} 
                                key={`cancer-name-${index}`} 
                            />
                        ))}
                    </div>
                    <div className={styles.paginationContainer}>
                        {pageNumbers.map(number => (
                            <span 
                                key={number} 
                                className={currentPage === number ? styles.activePage : styles.pageNumber} 
                                onClick={() => handlePageClick(number)}
                            >
                                {number}
                            </span>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}

export default PDOModel;